// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./themes/inspinia/css/style.scss
// module id = 1307
// module chunks = 0